"use client";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { memo as l, forwardRef as s } from "react";
import { useSvgIcon as p } from "../useSvgIcon.js";
const a = l(
  s((r, t) => {
    const { monochrome: C, ...i } = r, n = p({
      ...i,
      ref: t
    });
    return /* @__PURE__ */ e(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...n(),
        children: [
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0.714624 15.7488C0.713823 18.4271 1.42114 21.0423 2.76623 23.3474L0.585938 31.2236L8.73271 29.1102C10.9772 30.3205 13.5043 30.9592 16.0762 30.9601H16.0831C24.5525 30.9601 31.4469 24.1414 31.4504 15.7606C31.4521 11.6994 29.8549 7.88074 26.9533 5.00783C24.0521 2.13492 20.1935 0.551943 16.0825 0.550131C7.61208 0.550131 0.718059 7.36825 0.714624 15.7488Z",
              fill: C ? "" : "url(#paint0_linear_5283_435)"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0.153199 15.7436C0.152168 18.5185 0.88502 21.2273 2.27796 23.615L0.0195312 31.7734L8.45854 29.5842C10.7836 30.8387 13.4014 31.4999 16.0656 31.5008H16.0724C24.8458 31.5008 31.9877 24.437 31.9914 15.7564C31.9929 11.5491 30.3385 7.59336 27.3332 4.61737C24.3274 1.64149 20.3306 0.00188065 16.0724 -4.57764e-05C7.29761 -4.57764e-05 0.15669 7.06268 0.153141 15.7436H0.153199ZM5.17869 23.2039L4.86367 22.7089C3.53913 20.6253 2.83988 18.2173 2.84103 15.7447C2.84383 8.52932 8.77906 2.65929 16.0775 2.65929C19.6118 2.66071 22.9334 4.02365 25.4318 6.49711C27.9299 8.9704 29.3046 12.2585 29.3036 15.7553C29.3005 22.9709 23.365 28.8418 16.0725 28.8418H16.0673C13.6927 28.8405 11.364 28.2098 9.3329 27.0173L8.84953 26.7339L3.84167 28.0329L5.17869 23.2039Z",
              fill: C ? "var(--icon-color)" : "url(#paint1_linear_5283_435)"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.0985 9.16181C11.8006 8.50653 11.4869 8.49334 11.2035 8.48184C10.9716 8.47204 10.7062 8.47266 10.4412 8.47266C10.176 8.47266 9.74502 8.57121 9.3806 8.965C9.01595 9.35879 7.98828 10.3107 7.98828 12.2469C7.98828 14.1833 9.41374 16.0541 9.61244 16.3169C9.81131 16.5793 12.3642 20.6794 16.4071 22.2568C19.7671 23.5677 20.4509 23.307 21.1802 23.2414C21.9095 23.1758 23.5335 22.2896 23.865 21.3707C24.1965 20.4519 24.1965 19.6644 24.097 19.4997C23.9976 19.3357 23.7324 19.2373 23.3346 19.0405C22.9367 18.8437 20.9813 17.8916 20.6166 17.7604C20.252 17.6292 19.9867 17.5636 19.7216 17.9576C19.4564 18.3512 18.6946 19.2373 18.4624 19.4998C18.2304 19.7628 17.9984 19.7955 17.6005 19.5987C17.2027 19.4014 15.9216 18.9862 14.4019 17.6456C13.2195 16.6026 12.4212 15.3145 12.189 14.9205C11.957 14.5269 12.1643 14.3138 12.3638 14.1176C12.5424 13.9413 12.7616 13.6582 12.9605 13.4284C13.1589 13.1986 13.2253 13.0346 13.3579 12.7722C13.4904 12.5094 13.4242 12.2796 13.3247 12.0829C13.2253 11.8861 12.4523 9.93987 12.0985 9.16181Z",
              fill: C ? "var(--icon-color)" : "white"
            }
          ),
          /* @__PURE__ */ e("defs", { children: [
            /* @__PURE__ */ e(
              "linearGradient",
              {
                id: "paint0_linear_5283_435",
                x1: "16.0181",
                y1: "31.2237",
                x2: "16.0181",
                y2: "0.550102",
                gradientUnits: "userSpaceOnUse",
                children: [
                  /* @__PURE__ */ o("stop", { stopColor: "#20B038" }),
                  /* @__PURE__ */ o("stop", { offset: "1", stopColor: "#60D66A" })
                ]
              }
            ),
            /* @__PURE__ */ e(
              "linearGradient",
              {
                id: "paint1_linear_5283_435",
                x1: "16.0055",
                y1: "31.7735",
                x2: "16.0055",
                y2: "-2.79958e-05",
                gradientUnits: "userSpaceOnUse",
                children: [
                  /* @__PURE__ */ o("stop", { stopColor: "#F9F9F9" }),
                  /* @__PURE__ */ o("stop", { offset: "1", stopColor: "white" })
                ]
              }
            )
          ] })
        ]
      }
    );
  })
);
a.displayName = "IconWhatsApp";
export {
  a as IconWhatsApp
};
